import { userPermissions } from '@/common/constants'

export const permissionsList = t => [
  {
    key: 'transactions',
    label: t('Transacciones'),
    configurationSection: false,
    permissions: [],
    subgroups: [
      {
        label: t('Estado y validación'),
        permissions: [
          {
            label: t('Cambiar estado de la transacción'),
            value: userPermissions.editReturnStatus,
          },
        ],
      },
      {
        label: t('Cambios'),
        permissions: [
          {
            label: t('Crear pedidos de cambio'),
            value: userPermissions.editExchangeOrders,
          },
        ],
      },
      {
        label: t('Reembolsos y pagos'),
        permissions: [
          {
            label: t('Cambiar estado de pago o reembolso'),
            value: userPermissions.editIssueRefund,
          },
          {
            label: t('Editar el total del reembolso o pago'),
            value: userPermissions.editTransactionTotal,
          },
          {
            label: t('Cambiar método de reembolso'),
            value: userPermissions.editRefundMethod,
          },
          {
            label: t('Anular crédito en tienda o tarjeta regalo'),
            value: userPermissions.editStoreCreditGiftCard,
          },
        ],
      },
      {
        label: t('Vistas'),
        permissions: [
          {
            label: t('Mostrar vistas predefinidas'),
            value: userPermissions.viewTransactionsDefaultViews,
          },
          {
            label: t('Editar y compartir vistas'),
            value: userPermissions.editTransactionsViews,
          },
          {
            label: t('Compartir vistas con todos los grupos de usuario'),
            value: userPermissions.shareTransactionsViews,
          },
        ],
      },
      {
        label: t('Varios'),
        permissions: [
          {
            label: t('Solicitar nueva etiqueta de devolución'),
            value: userPermissions.editReturnLabels,
          },
          {
            label: t('Editar datos del cliente'),
            value: userPermissions.editCustomerData,
          },
          {
            label: t('Reponer productos aceptados'),
            value: userPermissions.restockProducts,
          },
        ],
      },
    ],
  },
  {
    key: 'shipments',
    label: t('Envíos'),
    configurationSection: false,
    permissions: [
      {
        label: t('Lectura'),
        value: userPermissions.viewShipments,
      },
      {
        label: t('Preparar envío'),
        value: userPermissions.prepareShipment,
      },
      {
        label: t('Editar detalles del envío'),
        value: userPermissions.editShipmentDetails,
      },
      {
        label: t('Cancelar envío'),
        value: userPermissions.cancelShipment,
      },
    ],
  },
  {
    key: 'inventory',
    label: t('Inventario'),
    configurationSection: false,
    permissions: [
      { label: t('Lectura'), value: userPermissions.viewShipmentsInventory },
      { label: t('Edición'), value: userPermissions.editShipmentsInventory },
    ],
  },
  {
    key: 'metrics',
    label: t('Métricas'),
    configurationSection: false,
    permissions: [
      {
        label: t('Lectura'),
        value: userPermissions.viewMetrics,
      },
    ],
  },
  {
    key: 'billing',
    label: t('Facturas'),
    configurationSection: false,
    permissions: [
      {
        label: t('Lectura'),
        value: userPermissions.viewBilling,
      },
    ],
  },
  {
    key: 'store',
    label: t('Tienda'),
    configurationSection: true,
    permissions: [
      {
        label: t('Lectura'),
        value: userPermissions.viewStore,
      },
      {
        label: t('Edición'),
        value: userPermissions.editStore,
      },
    ],
  },
  {
    key: 'returnsPolicy',
    label: t('Política de devoluciones'),
    configurationSection: true,
    permissions: [
      {
        label: t('Lectura'),
        value: userPermissions.viewPolicy,
      },
      {
        label: t('Edición'),
        value: userPermissions.editPolicy,
      },
    ],
    subgroups: [
      {
        label: t('Reglas condicionales'),
        permissions: [
          {
            label: t('Lectura'),
            value: userPermissions.viewPolicyRules,
          },
          {
            label: t('Edición'),
            value: userPermissions.editPolicyRules,
          },
        ],
      },
      {
        label: t('Excepciones'),
        permissions: [
          {
            label: t('Lectura'),
            value: userPermissions.viewAllowedList,
          },
          {
            label: t('Edición'),
            value: userPermissions.editAllowedList,
          },
        ],
      },
    ],
  },
  {
    key: 'refunds',
    label: t('Reembolsos'),
    configurationSection: true,
    permissions: [
      {
        label: t('Lectura'),
        value: userPermissions.viewRefunds,
      },
      {
        label: t('Edición'),
        value: userPermissions.editRefunds,
      },
    ],
  },
  {
    key: 'logistics',
    label: t('Logística'),
    configurationSection: true,
    permissions: [
      {
        label: t('Lectura'),
        value: userPermissions.viewLogistics,
      },
      {
        label: t('Edición'),
        value: userPermissions.editLogistics,
      },
    ],
  },
  {
    key: 'returnReasons',
    label: t('Motivos devolución'),
    configurationSection: true,
    permissions: [
      {
        label: t('Lectura'),
        value: userPermissions.viewReturnReasons,
      },
      {
        label: t('Edición'),
        value: userPermissions.editReturnReasons,
      },
    ],
  },
  {
    key: 'inventory',
    label: t('Inventario'),
    configurationSection: true,
    permissions: [
      {
        label: t('Lectura'),
        value: userPermissions.viewShipmentsSettings,
      },
      {
        label: t('Edición'),
        value: userPermissions.editShipmentsSettings,
      },
    ],
  },
  {
    key: 'branding',
    label: t('Branding'),
    configurationSection: true,
    permissions: [
      {
        label: t('Lectura'),
        value: userPermissions.viewBranding,
      },
      {
        label: t('Edición'),
        value: userPermissions.editBranding,
      },
    ],
  },
  {
    key: 'texts',
    label: t('Portal devoluciones'),
    configurationSection: true,
    permissions: [
      {
        label: t('Lectura'),
        value: userPermissions.viewCopies,
      },
      {
        label: t('Edición'),
        value: userPermissions.editCopies,
      },
    ],
  },
  {
    key: 'communications',
    label: t('Comunicaciones'),
    configurationSection: true,
    permissions: [
      {
        label: t('Lectura'),
        value: userPermissions.viewCommunications,
      },
      {
        label: t('Edición'),
        value: userPermissions.editCommunications,
      },
    ],
  },
  {
    key: 'billingSettings',
    label: t('Facturación'),
    configurationSection: true,
    permissions: [
      {
        label: t('Lectura'),
        value: userPermissions.viewBillingSettings,
      },
      {
        label: t('Edición'),
        value: userPermissions.editBillingSettings,
      },
    ],
  },
  {
    key: 'integrations',
    label: t('Integraciones'),
    configurationSection: true,
    permissions: [
      {
        label: t('Lectura'),
        value: userPermissions.viewIntegrations,
      },
      {
        label: t('Edición'),
        value: userPermissions.editIntegrations,
      },
    ],
  },
  {
    key: 'users',
    label: t('Usuarios'),
    configurationSection: true,
    permissions: [
      {
        label: t('Lectura'),
        value: userPermissions.viewUsers,
      },
      {
        label: t('Añadir, editar y eliminar usuarios, y restablecer sus contraseñas.'),
        value: userPermissions.editUsers,
      },
      {
        label: t('Crear, editar y eliminar grupos de permisos, y cambiar lo que puede hacer cada grupo.'),
        value: userPermissions.editGroups,
      },
    ],
  },
  {
    key: 'extra',
    label: t('Widgets'),
    configurationSection: true,
    permissions: [
      {
        label: t('Lectura'),
        value: userPermissions.viewExtra,
      },
      {
        label: t('Edición'),
        value: userPermissions.editExtra,
      },
    ],
  },
  {
    key: 'returnProtection',
    label: t('Return Protection'),
    configurationSection: true,
    featureGated: true,
    permissions: [
      {
        label: t('Lectura'),
        value: userPermissions.viewReturnProtection,
      },
      {
        label: t('Edición'),
        value: userPermissions.editReturnProtection,
      },
    ],
  },
  {
    key: 'orderTrackingPage',
    label: t('Página de seguimiento del pedido'),
    configurationSection: true,
    permissions: [
      {
        label: t('Lectura'),
        value: userPermissions.viewOrderTrackingPage,
      },
      {
        label: t('Edición'),
        value: userPermissions.editOrderTrackingPage,
      },
    ],
  },
]
